import { CSSProperties } from "react";

import { Image } from "#shared/view/components/Image";

import Folder from "./png/folder.png";

export type IllustrationName = "folder" | "shape-1" | "shape-2" | "shape-3";

type Props = {
  name: IllustrationName;
  size?: number;
  style?: CSSProperties;
};

const SHAPE_SIZE = 75;

export const Illustration = ({ name, size = SHAPE_SIZE, style }: Props) => {
  switch (name) {
    case "folder":
      return <Image src={Folder} w={145} h={87} ml={50} />;
    case "shape-1":
      return <Image src={"/images/illu-3D-1.png"} w={size} h={size} style={style} />;
    case "shape-2":
      return <Image src={"/images/illu-3D-2.png"} w={size} h={size} style={style} />;
    case "shape-3":
      return <Image src={"/images/illu-3D-3.png"} w={size} h={size} style={style} />;

    default:
      return null;
  }
};
